<template>
	<div>
		<div v-if="loading">
			<loader></loader>
		</div>
		<div id="canvas">
			<img class="previous-page" src="../../img/left.svg" value="previous" @click="pagePrev" />
			<img class="next-page" src="../../img/right.svg" value="next" @click="pageNext" />
			<div class="flipbook-viewport">
				<div class="col-auto float-left bar">
					<router-link style="padding-right: 70px" to="/home">Kiosk</router-link>
					<a to v-if="!index" @click="cambiarEstado('/index')">Index</a>
					<a to="/index" v-else @click="cambiarEstado('')">Close</a>
				</div>
				<div class="col-auto float-right">
					<a class="zoom-icon zoom-icon-in">Fullscreen</a>
				</div>
				<div class="container">
					<div class="flipbook" id="btnClick" @keyup.right="pause" @keyup.left="pause" @click.prevent="pause">
						<div :style="'background-image:url(' + pages8[0] + ')'"></div>
						<div :style="'background-image:url(' + pages8[1] + ')'"></div>
						<div :style="'background-image:url(' + pages8[2] + ')'"></div>
						<div :style="'background-image:url(' + pages8[3] + ')'"></div>
						<div :style="'background-image:url(' + pages8[4] + ')'"></div>
						<div :style="'background-image:url(' + pages8[5] + ')'"></div>
						<div :style="'background-image:url(' + pages8[6] + ')'"></div>
						<div :style="'background-image:url(' + pages8[7] + ')'"></div>
						<div :style="'background-image:url(' + pages8[8] + ')'"></div>
						<div :style="'background-image:url(' + pages8[9] + ')'"></div>
						<div :style="'background-image:url(' + pages8[10] + ')'"></div>
						<div :style="'background-image:url(' + pages8[11] + ')'"></div>
						<div :style="'background-image:url(' + pages8[12] + ')'"></div>
						<div :style="'background-image:url(' + pages8[13] + ')'"></div>
						<div :style="'background-image:url(' + pages8[14] + ')'"></div>
						<div :style="'background-image:url(' + pages8[15] + ')'"></div>
						<div :style="'background-image:url(' + pages8[16] + ')'"></div>
						<div :style="'background-image:url(' + pages8[17] + ')'"></div>
						<div :style="'background-image:url(' + pages8[18] + ')'"></div>
						<div :style="'background-image:url(' + pages8[19] + ')'"></div>
						<div :style="'background-image:url(' + pages8[20] + ')'"></div>
						<div :style="'background-image:url(' + pages8[21] + ')'"></div>
						<div :style="'background-image:url(' + pages8[22] + ')'"></div>
						<div :style="'background-image:url(' + pages8[23] + ')'"></div>
						<div :style="'background-image:url(' + pages8[24] + ')'"></div>
						<div :style="'background-image:url(' + pages8[25] + ')'"></div>
						<div :style="'background-image:url(' + pages8[26] + ')'">
							<a class="minilinks articles2" style="bottom: 14.8%; left: 24.2%; width: 8%;" target="_blank"
								@click="openLink('https://fpm.climatepartner.com/tracking/13766-2209-1004/en?utm_source=climatepartner.com&utm_medium=id')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[27] + ')'"></div>
						<div :style="'background-image:url(' + pages8[28] + ')'"></div>
						<div :style="'background-image:url(' + pages8[29] + ')'"></div>
						<div :style="'background-image:url(' + pages8[30] + ')'"></div>
						<div :style="'background-image:url(' + pages8[31] + ')'"></div>
						<div :style="'background-image:url(' + pages8[32] + ')'"></div>
						<div :style="'background-image:url(' + pages8[33] + ')'">
							<a class="minilinks articles2" style="bottom: 20.1%; left: 6.8%; width: 16%;" target="_blank"
								@click="openLink('https://www.instagram.com/hadiqa_bashir/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[34] + ')'">
						</div>
						<div :style="'background-image:url(' + pages8[35] + ')'">
							<a class="minilinks articles2" style="bottom: 79.1%; left: 52.5%; width: 8%" target="_blank"
								@click="openLink('https://ethique.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 72.8%; left: 72.8%; width: 11.2%" target="_blank"
								@click="openLink('https://palaeyewear.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 61.8%; left: 12.6%; width: 13.6%" target="_blank"
								@click="openLink('https://www.stefaniavaidani.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 54.4%; left: 44.8%; width: 13.2%" target="_blank"
								@click="openLink('https://us.viron-world.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 51.8%; right: 17.8%; width: 8%" target="_blank"
								@click="openLink('https://www.cuyana.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 39.4%; left: 16.4%; width: 14%" target="_blank"
								@click="openLink('https://oneseedperfumes.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 27.2%; left: 38.4%; width: 11.6%" target="_blank"
								@click="openLink('https://unitedbyblue.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 13.2%; left: 33.4%; width: 16.2%" target="_blank"
								@click="openLink('https://www.talabarbotinkhalidy.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 21.9%; right: 13.2%; width: 9.4%" target="_blank"
								@click="openLink('https://auterra.co.za')">clik</a>
							<a class="minilinks articles2" style="bottom: 12%; right: 15.8%; width: 8.2%" target="_blank"
								@click="openLink('https://ayni.com.pe/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[36] + ')'">
							<a class="minilinks articles2" style="bottom: 66.6%; left: 14%; width: 13.5%" target="_blank"
								@click="openLink('https://goshcopenhagen.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 82.4%; left: 50%; width: 10.3%" target="_blank"
								@click="openLink('https://www.kmbylange.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 56.8%; right: 35%; width: 10%" target="_blank"
								@click="openLink('https://pajarapinta.co')">clik</a>
							<a class="minilinks articles2" style="bottom: 67.6%; right: 15.4%; width: 9.4%" target="_blank"
								@click="openLink('https://www.aurstudio.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 46.7%; right: 15.2%; width: 9.2%" target="_blank"
								@click="openLink('https://www.khalimin.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 39.8%; right: 39%; width: 14.6%" target="_blank"
								@click="openLink('https://www.thecommongoodco.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 32.1%; right: 29%; width: 6%" target="_blank"
								@click="openLink('https://maydi.co')">clik</a>
							<a class="minilinks articles2" style="bottom: 10.6%; right: 38.2%; width: 10.5%" target="_blank"
								@click="openLink('https://www.paiskincare.us')">clik</a>
							<a class="minilinks articles2" style="bottom: 16%; left: 35.8%; width: 8.4%" target="_blank"
								@click="openLink('https://rifo-lab.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 11.7%; left:14%; width: 8.8%" target="_blank"
								@click="openLink('https://www.ottolinger.com')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[37] + ')'">
							<a class="minilinks articles2" style="bottom: 76.8%; left: 31%; width: 9.2%" target="_blank"
								@click="openLink('https://make-land.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 60.1%; right: 31%; width: 9.2%" target="_blank"
								@click="openLink('https://article22.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 51%; left: 18%; width: 16%" target="_blank"
								@click="openLink('https://wildmountainwax.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 44.6%; right: 11%; width: 11.5%" target="_blank"
								@click="openLink('https://www.philiphuang.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 18.1%; right: 6%; width: 9.4%" target="_blank"
								@click="openLink('https://www.fairphone.com/en/')">clik</a>
							<a class="minilinks articles2" style="bottom: 11%; right: 25.4%; width: 11.4%" target="_blank"
								@click="openLink('https://www.flamingoslife.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 29.6%; right: 29%; width: 15.4%" target="_blank"
								@click="openLink('https://houdinisportswear.com/en-us')">clik</a>
							<a class="minilinks articles2" style="bottom: 11.9%; left: 42%; width: 7%" target="_blank"
								@click="openLink('https://www.triwa.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 30.1%; left: 30%; width: 13.2%" target="_blank"
								@click="openLink('https://www.kseniaschnaider.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[38] + ')'">
							<a class="minilinks articles2" style="bottom: 76.1%; left: 39.8%; width: 13.4%" target="_blank"
								@click="openLink('https://wawwaclothing.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 59.2%; left: 19.2%; width: 8.5%" target="_blank"
								@click="openLink('https://pangaia.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 67.7%; right: 26%; width: 9%" target="_blank"
								@click="openLink('https://haeckels.co.uk')">clik</a>
							<a class="minilinks articles2" style="bottom: 51%; right: 13%; width: 15%" target="_blank"
								@click="openLink('https://www.oxmantownskincare.ie/')">clik</a>
							<a class="minilinks articles2" style="bottom: 33.7%; left: 16.2%; width: 9.8%" target="_blank"
								@click="openLink('https://maium.nl')">clik</a>
							<a class="minilinks articles2" style="bottom: 38.2%; right: 13.2%; width: 11.4%" target="_blank"
								@click="openLink('https://jungleculture.eco/')">clik</a>
							<a class="minilinks articles2" style="bottom: 30.4%; right: 25.6%; width: 10.5%" target="_blank"
								@click="openLink('https://us.abelodor.com')">clik</a>
							<a class="minilinks articles2" style="bottom: 11.8%; right: 35.4%; width: 11%" target="_blank"
								@click="openLink('https://gmbhgmbh.eu/shop/')">clik</a>
							<a class="minilinks articles2" style="bottom: 13.4%; left: 16.2%; width: 14%" target="_blank"
								@click="openLink('https://colorfulstandard.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[39] + ')'"></div>
						<div :style="'background-image:url(' + pages8[40] + ')'"></div>
						<div :style="'background-image:url(' + pages8[41] + ')'"></div>
						<div :style="'background-image:url(' + pages8[42] + ')'"></div>
						<div :style="'background-image:url(' + pages8[43] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 33%; width: 11.2%" target="_blank"
								@click="openLink('https://www.instagram.com/ghazalmia/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[44] + ')'"></div>
						<div :style="'background-image:url(' + pages8[45] + ')'"></div>
						<div :style="'background-image:url(' + pages8[46] + ')'"></div>
						<div :style="'background-image:url(' + pages8[47] + ')'"></div>
						<div :style="'background-image:url(' + pages8[48] + ')'"></div>
						<div :style="'background-image:url(' + pages8[49] + ')'"></div>
						<div :style="'background-image:url(' + pages8[50] + ')'"></div>
						<div :style="'background-image:url(' + pages8[51] + ')'"></div>
						<div :style="'background-image:url(' + pages8[52] + ')'">
							<a class="minilinks articles2" @click="onPlayerReadyTbt(media[140])"
								style="bottom: 29.2%; right: 8%; width: 13%; font-size: 1rem; text-decoration: none"> ClicktoPlay </a>
						</div>
						<div :style="'background-image:url(' + pages8[53] + ')'"></div>
						<div :style="'background-image:url(' + pages8[54] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 37.2%; width: 15.4%" target="_blank"
								@click="openLink('https://www.andzejgavriss.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[55] + ')'"></div>
						<div :style="'background-image:url(' + pages8[56] + ')'"></div>
						<div :style="'background-image:url(' + pages8[57] + ')'">
							<a class="links articles2" style="bottom: 27.4%; right: 32%; width: 12%" target="_blank"
								@click="openLink('https://www.instagram.com/ilaydaeskt/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[58] + ')'"></div>
						<div :style="'background-image:url(' + pages8[59] + ')'"></div>
						<div :style="'background-image:url(' + pages8[60] + ')'"></div>
						<div :style="'background-image:url(' + pages8[61] + ')'">
						</div>
						<div :style="'background-image:url(' + pages8[62] + ')'"></div>
						<div :style="'background-image:url(' + pages8[63] + ')'"></div>
						<div :style="'background-image:url(' + pages8[64] + ')'">
							<a class="links articles2" style="bottom: 12%; left: 9.4%; width: 24.5%" target="_blank"
								@click="openLink('https://www.instagram.com/gwen_myers_peacemessenger/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[65] + ')'"></div>
						<div :style="'background-image:url(' + pages8[66] + ')'"></div>
						<div :style="'background-image:url(' + pages8[67] + ')'"></div>
						<div :style="'background-image:url(' + pages8[68] + ')'"></div>
						<div :style="'background-image:url(' + pages8[69] + ')'"></div>
						<div :style="'background-image:url(' + pages8[70] + ')'"></div>
						<div :style="'background-image:url(' + pages8[71] + ')'"></div>
						<div :style="'background-image:url(' + pages8[72] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 39.4%; width: 13%" target="_blank"
								@click="openLink('https://www.comcavis.org.sv/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[73] + ')'"></div>
						<div :style="'background-image:url(' + pages8[74] + ')'"></div>
						<div :style="'background-image:url(' + pages8[75] + ')'"></div>
						<div :style="'background-image:url(' + pages8[76] + ')'"></div>
						<div :style="'background-image:url(' + pages8[77] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 26%; width: 18.5%" target="_blank"
								@click="openLink('http://jeremiahthoronka.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[78] + ')'"></div>
						<div :style="'background-image:url(' + pages8[79] + ')'"></div>
						<div :style="'background-image:url(' + pages8[80] + ')'"></div>
						<div :style="'background-image:url(' + pages8[81] + ')'"></div>
						<div :style="'background-image:url(' + pages8[82] + ')'"></div>
						<div :style="'background-image:url(' + pages8[83] + ')'"></div>
						<div :style="'background-image:url(' + pages8[84] + ')'"></div>
						<div :style="'background-image:url(' + pages8[85] + ')'"></div>
						<div :style="'background-image:url(' + pages8[86] + ')'"></div>
						<div :style="'background-image:url(' + pages8[87] + ')'"></div>
						<div :style="'background-image:url(' + pages8[88] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 39.8%; width: 12.8%" target="_blank"
								@click="openLink('https://www.aerobotics7.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[89] + ')'"></div>
						<div :style="'background-image:url(' + pages8[90] + ')'">
							<a class="links articles2" style="bottom: 41.7%; right: 33.4%; width: 12.2%" target="_blank"
								@click="openLink('https://twitter.com/jichen_liu?lang=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[91] + ')'">
							<a class="links articles2" style="bottom: 11.7%; left: 32.8%; width: 6%" target="_blank"
								@click="openLink('https://www.levi.com/US/en_US/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[92] + ')'"></div>
						<div :style="'background-image:url(' + pages8[93] + ')'"></div>
						<div :style="'background-image:url(' + pages8[94] + ')'"></div>
						<div :style="'background-image:url(' + pages8[95] + ')'"></div>
						<div :style="'background-image:url(' + pages8[96] + ')'">
							<a class="links articles2" style="bottom: 17%; right: 13.2%; width: 16.8%" target="_blank"
								@click="openLink('https://www.ysl.com/en-us')">clik</a>
							<a class="links articles2" style="bottom: 14.6%; right: 15%; width: 26.8%" target="_blank"
								@click="openLink('https://www.ysl.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[97] + ')'"></div>
						<div :style="'background-image:url(' + pages8[98] + ')'"></div>
						<div :style="'background-image:url(' + pages8[99] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 28.2%; width: 16%" target="_blank"
								@click="openLink('https://www.instagram.com/aidanrgallagher/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[100] + ')'">
							<a class="links articles2" style="bottom: 22.8%; right: 7%; width: 7%" target="_blank"
								@click="openLink('https://www.gucci.com/us/en/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[101] + ')'"></div>
						<div :style="'background-image:url(' + pages8[102] + ')'"></div>
						<div :style="'background-image:url(' + pages8[103] + ')'"></div>
						<div :style="'background-image:url(' + pages8[104] + ')'"></div>
						<div :style="'background-image:url(' + pages8[105] + ')'"></div>
						<div :style="'background-image:url(' + pages8[106] + ')'"></div>
						<div :style="'background-image:url(' + pages8[107] + ')'"></div>
						<div :style="'background-image:url(' + pages8[108] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 39%; width: 13.5%" target="_blank"
								@click="openLink('https://www.instagram.com/keishiathorpe/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[109] + ')'"></div>
						<div :style="'background-image:url(' + pages8[110] + ')'"></div>
						<div :style="'background-image:url(' + pages8[111] + ')'"></div>
						<div :style="'background-image:url(' + pages8[112] + ')'"></div>
						<div :style="'background-image:url(' + pages8[113] + ')'"></div>
						<div :style="'background-image:url(' + pages8[114] + ')'">
							<a class="links articles2" style="bottom: 12.8%; right: 43.2%; width: 8.6%" target="_blank"
								@click="openLink('https://www.instagram.com/xueli_a/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[115] + ')'"></div>
						<div :style="'background-image:url(' + pages8[116] + ')'">
							<a class="links articles2" style="bottom: 58.4%; right: 30%; width: 15.6%" target="_blank"
								@click="openLink('https://twitter.com/lesterphilipp?lang=en-GB')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[117] + ')'"></div>
						<div :style="'background-image:url(' + pages8[118] + ')'"></div>
						<div :style="'background-image:url(' + pages8[119] + ')'"></div>
						<div :style="'background-image:url(' + pages8[120] + ')'"></div>
						<div :style="'background-image:url(' + pages8[121] + ')'"></div>
						<div :style="'background-image:url(' + pages8[122] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 41.4%; width: 10.4%" target="_blank"
								@click="openLink('https://twitter.com/SaroImran/status/826843598620487681')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[123] + ')'"></div>
						<div :style="'background-image:url(' + pages8[124] + ')'"></div>
						<div :style="'background-image:url(' + pages8[125] + ')'"></div>
						<div :style="'background-image:url(' + pages8[126] + ')'"></div>
						<div :style="'background-image:url(' + pages8[127] + ')'"></div>
						<div :style="'background-image:url(' + pages8[128] + ')'">
							<a class="links articles2" style="bottom: 10.4%; right: 40%; width: 12.2%" target="_blank"
								@click="openLink('https://www.instagram.com/miss_sadya/?hl=fr')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[129] + ')'"></div>
						<div :style="'background-image:url(' + pages8[130] + ')'"></div>
						<div :style="'background-image:url(' + pages8[131] + ')'"></div>
						<div :style="'background-image:url(' + pages8[132] + ')'"></div>
						<div :style="'background-image:url(' + pages8[133] + ')'"></div>
						<div :style="'background-image:url(' + pages8[134] + ')'"></div>
						<div :style="'background-image:url(' + pages8[135] + ')'"></div>
						<div :style="'background-image:url(' + pages8[136] + ')'">
							<a class="links articles2" style="bottom: 12.8%; right: 41%; width: 11.5%" target="_blank"
								@click="openLink('https://www.instagram.com/bikodesigns/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[137] + ')'"></div>
						<div :style="'background-image:url(' + pages8[138] + ')'"></div>
						<div :style="'background-image:url(' + pages8[139] + ')'">
							<a class="links articles2" style="bottom: 10.6%; left: 7%; width: 14%" target="_blank"
								@click="openLink('https://www.instagram.com/loayradwan/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[140] + ')'"></div>
						<div :style="'background-image:url(' + pages8[141] + ')'"></div>
						<div :style="'background-image:url(' + pages8[142] + ')'"></div>
						<div :style="'background-image:url(' + pages8[143] + ')'"></div>
						<div :style="'background-image:url(' + pages8[144] + ')'"></div>
						<div :style="'background-image:url(' + pages8[145] + ')'"></div>
						<div :style="'background-image:url(' + pages8[146] + ')'"></div>
						<div :style="'background-image:url(' + pages8[147] + ')'"></div>
						<div :style="'background-image:url(' + pages8[148] + ')'"></div>
						<div :style="'background-image:url(' + pages8[149] + ')'"></div>
						<div :style="'background-image:url(' + pages8[150] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 39.2%; width: 13.5%" target="_blank"
								@click="openLink('https://www.instagram.com/jayathmadw/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[151] + ')'"></div>
						<div :style="'background-image:url(' + pages8[152] + ')'"></div>
						<div :style="'background-image:url(' + pages8[153] + ')'"></div>
						<div :style="'background-image:url(' + pages8[154] + ')'"></div>
						<div :style="'background-image:url(' + pages8[155] + ')'"></div>
						<div :style="'background-image:url(' + pages8[156] + ')'"></div>
						<div :style="'background-image:url(' + pages8[157] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 35%; width: 9.5%" target="_blank"
								@click="openLink('https://www.instagram.com/aymusik/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[158] + ')'"></div>
						<div :style="'background-image:url(' + pages8[159] + ')'"></div>
						<div :style="'background-image:url(' + pages8[160] + ')'"></div>
						<div :style="'background-image:url(' + pages8[161] + ')'">
							<a class="links articles2" style="bottom: 41.6%; right: 32.4%; width: 12%" target="_blank"
								@click="openLink('https://www.instagram.com/djambony/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[162] + ')'"></div>
						<div :style="'background-image:url(' + pages8[163] + ')'"></div>
						<div :style="'background-image:url(' + pages8[164] + ')'"></div>
						<div :style="'background-image:url(' + pages8[165] + ')'"></div>
						<div :style="'background-image:url(' + pages8[166] + ')'"></div>
						<div :style="'background-image:url(' + pages8[167] + ')'"></div>
						<div :style="'background-image:url(' + pages8[168] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 37.5%; width: 15%;" target="_blank"
								@click="openLink('https://www.instagram.com/noraaltwaijri_/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[169] + ')'"></div>
						<div :style="'background-image:url(' + pages8[170] + ')'"></div>
						<div :style="'background-image:url(' + pages8[171] + ')'"></div>
						<div :style="'background-image:url(' + pages8[172] + ')'"></div>
						<div :style="'background-image:url(' + pages8[173] + ')'"></div>
						<div :style="'background-image:url(' + pages8[174] + ')'"></div>
						<div :style="'background-image:url(' + pages8[175] + ')'"></div>
						<div :style="'background-image:url(' + pages8[176] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 42%; width: 11%" target="_blank"
								@click="openLink('https://www.foodforsoul.it/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[177] + ')'"></div>
						<div :style="'background-image:url(' + pages8[178] + ')'"></div>
						<div :style="'background-image:url(' + pages8[179] + ')'">
							<a class="links articles2" style="bottom: 7.2%; right: 6%; width: 16%" target="_blank"
								@click="openLink('https://www.makeupbymario.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[180] + ')'"></div>
						<div :style="'background-image:url(' + pages8[181] + ')'">
							<a class="links articles2" style="bottom: 16.5%; left: 20.4%; width: 7%" target="_blank"
								@click="openLink('https://www.chanel.com/gb/makeup/?gclid=Cj0KCQjw1bqZBhDXARIsANTjCPJUkagEC4DJqonIb0DJtGTPaVcfGQlD4u3eqE3j5veuhzAiTr5MC-saAi-REALw_wcB')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[182] + ')'"></div>
						<div :style="'background-image:url(' + pages8[183] + ')'">
							<a class="links articles2" style="bottom: 80.3%; left: 15.5%; width: 8.6%" target="_blank"
								@click="openLink('https://www.givenchybeauty.com/gb?gclid=Cj0KCQjw1bqZBhDXARIsANTjCPKnvQ-hVGTGzgE-meZDkJD5bAEhePxgrfpqxiOeG-SSKremFVqR-F8aAiq4EALw_wcB')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[184] + ')'">
							<a class="links articles2" style="bottom: 16.6%; right: 6%; width: 16.2%" target="_blank"
								@click="openLink('https://www.patmcgrath.com/collections/celestial-nirvana?utm_source=google&utm_medium=cpc&utm_campaign=sw_2020_q4_brand_core_terms_exact&gclid=Cj0KCQjw1bqZBhDXARIsANTjCPLE9yscrRY2P5SrRLlli99YSPlFnm39IBEfqnQ8FZQySfqHoe0b01oaAlh1EALw_wcB')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[185] + ')'">
							<a class="minilinks articles2" style="bottom: 16%; left: 20%; width: 6.2%" target="_blank"
								@click="openLink('https://www.dior.com/en_gb/beauty/make-up/new-makeup?gclid=Cj0KCQjw1bqZBhDXARIsANTjCPKcd7Sz2cpT1jRU3y4Bb7u8DWyxw7mfMHAcg2vfW4uZir71wt1qRTkaAkx7EALw_wcB')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[186] + ')'"></div>
						<div :style="'background-image:url(' + pages8[187] + ')'"></div>
						<div :style="'background-image:url(' + pages8[188] + ')'">
							<a class="minilinks articles2" style="bottom: 18.5%; right: 6%; width: 17.5%" target="_blank"
								@click="openLink('https://www.maccosmetics.co.uk/?gclid=Cj0KCQjw1bqZBhDXARIsANTjCPJDfOHm8kZt7UNFk5VA2g0_hpWC6qpHiW1B5YaVzbbhwrkqmRTs4IMaAju4EALw_wcB&gclsrc=aw.ds')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[189] + ')'">
							<a class="minilinks articles2" style="bottom: 81.2%; left: 5.6%; width: 18.5%" target="_blank"
								@click="openLink('https://www.hourglasscosmetics.com/')">clik</a>
					</div>
						<div :style="'background-image:url(' + pages8[190] + ')'">
							<a class="links articles2" style="bottom: 7.4%; left: 25%; width: 7.5%" target="_blank"
								@click="openLink('https://www.dior.com/en_gb/beauty/make-up/new-makeup?gclid=Cj0KCQjw1bqZBhDXARIsANTjCPKcd7Sz2cpT1jRU3y4Bb7u8DWyxw7mfMHAcg2vfW4uZir71wt1qRTkaAkx7EALw_wcB')">clik</a>
					</div>
						<div :style="'background-image:url(' + pages8[191] + ')'">
							<a class="minilinks articles2" style="bottom: 23.2%; left: 5.6%; width: 18.5%" target="_blank"
								@click="openLink('https://www.charlottetilbury.com/uk?bcndyn=d2lkOjUwMHxjaWQ6NTc2&gad_id=594133186265&utm_campaign=UK+%3E+Charlotte+Tilbury+%3E+Brand+%3E+Pure+%3E+Exact&&nst=0&gclid=Cj0KCQjw1bqZBhDXARIsANTjCPIi6cTOBF_vTWuKFhD2J2Tln9M8tLqaKu436e-1YIrk_iiKTt38LrYaAkS5EALw_wcB&gclsrc=aw.ds')">clik</a>
					</div>
						<div :style="'background-image:url(' + pages8[192] + ')'"></div>
						<div :style="'background-image:url(' + pages8[193] + ')'"></div>
						<div :style="'background-image:url(' + pages8[194] + ')'"></div>
						<div :style="'background-image:url(' + pages8[195] + ')'"></div>
						<div :style="'background-image:url(' + pages8[196] + ')'"></div>
						<div :style="'background-image:url(' + pages8[197] + ')'"></div>
						<div :style="'background-image:url(' + pages8[198] + ')'"></div>
						<div :style="'background-image:url(' + pages8[199] + ')'"></div>
						<div :style="'background-image:url(' + pages8[200] + ')'"></div>
						<div :style="'background-image:url(' + pages8[201] + ')'"></div>
						<div :style="'background-image:url(' + pages8[202] + ')'">
							<a class="minilinks articles2" @click="onPlayerTfg(media[141])"
								style="bottom: 26.4%; right: 6.6%; width: 13%; font-size: 1rem; text-decoration: none">ClicktoPlay</a>
						</div>
						<div :style="'background-image:url(' + pages8[203] + ')'"></div>
						<div :style="'background-image:url(' + pages8[204] + ')'">
							<a class="links articles2" style="bottom: 10.5%; left: 48%; width: 12%" target="_blank"
								@click="openLink('https://www.instagram.com/gelila.bekele/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[205] + ')'"></div>
						<div :style="'background-image:url(' + pages8[206] + ')'"></div>
						<div :style="'background-image:url(' + pages8[207] + ')'"></div>
						<div :style="'background-image:url(' + pages8[208] + ')'">
							<a class="links articles2" style="bottom: 63.2%; left: 54.2%; width: 16.5%" target="_blank"
								@click="openLink('https://www.instagram.com/ayodejiosowobi/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[209] + ')'"></div>
						<div :style="'background-image:url(' + pages8[210] + ')'"></div>
						<div :style="'background-image:url(' + pages8[211] + ')'"></div>
						<div :style="'background-image:url(' + pages8[212] + ')'"></div>
						<div :style="'background-image:url(' + pages8[213] + ')'"></div>
						<div :style="'background-image:url(' + pages8[214] + ')'"></div>
						<div :style="'background-image:url(' + pages8[215] + ')'"></div>
						<div :style="'background-image:url(' + pages8[216] + ')'"></div>
						<div :style="'background-image:url(' + pages8[217] + ')'"></div>
						<div :style="'background-image:url(' + pages8[218] + ')'"></div>
						<div :style="'background-image:url(' + pages8[219] + ')'"></div>
						<div :style="'background-image:url(' + pages8[220] + ')'">
							<a class="links articles2" style="bottom: 10.5%; left: 47.5%; width: 8%" target="_blank"
								@click="openLink('https://www.instagram.com/unesco/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[221] + ')'"></div>
						<div :style="'background-image:url(' + pages8[222] + ')'"></div>
						<div :style="'background-image:url(' + pages8[223] + ')'"></div>
						<div :style="'background-image:url(' + pages8[224] + ')'"></div>
						<div :style="'background-image:url(' + pages8[225] + ')'"></div>
						<div :style="'background-image:url(' + pages8[226] + ')'"></div>
						<div :style="'background-image:url(' + pages8[227] + ')'"></div>
						<div :style="'background-image:url(' + pages8[228] + ')'">
							<a class="links articles2" style="bottom: 10.5%; left: 47.4%; width: 16.8%;" target="_blank"
								@click="openLink('https://www.debeersgroup.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[229] + ')'"></div>
						<div :style="'background-image:url(' + pages8[230] + ')'"></div>
						<div :style="'background-image:url(' + pages8[231] + ')'"></div>
						<div :style="'background-image:url(' + pages8[232] + ')'"></div>
						<div :style="'background-image:url(' + pages8[233] + ')'"></div>
						<div :style="'background-image:url(' + pages8[234] + ')'"></div>
						<div :style="'background-image:url(' + pages8[235] + ')'"></div>
						<div :style="'background-image:url(' + pages8[236] + ')'">
							<a class="links articles2" style="bottom: 10.5%; left: 47.4%; width: 6%" target="_blank"
								@click="openLink('https://www.wfp.org/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[237] + ')'"></div>
						<div :style="'background-image:url(' + pages8[238] + ')'"></div>
						<div :style="'background-image:url(' + pages8[239] + ')'"></div>
						<div :style="'background-image:url(' + pages8[240] + ')'"></div>
						<div :style="'background-image:url(' + pages8[241] + ')'">
							<a class="links articles2" style="bottom: 12.8%; left: 56.2%; width: 20.6%" target="_blank"
								@click="openLink('https://www.instagram.com/thoughtsquadbymaria/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[242] + ')'"></div>
						<div :style="'background-image:url(' + pages8[243] + ')'"></div>
						<div :style="'background-image:url(' + pages8[244] + ')'"></div>
						<div :style="'background-image:url(' + pages8[245] + ')'"></div>
						<div :style="'background-image:url(' + pages8[246] + ')'"></div>
						<div :style="'background-image:url(' + pages8[247] + ')'">
							<a class="minilinks articles2" style="bottom: 39.3%; left: 6.8%; width: 16.5%;" target="_blank"
								@click="openLink('https://www.instagram.com/satta_f_sheriff_/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[248] + ')'"></div>
						<div :style="'background-image:url(' + pages8[249] + ')'"></div>
						<div :style="'background-image:url(' + pages8[250] + ')'">
							<a class="links articles2" style="bottom: 22.3%; left: 32.5%; width: 35%; font-size:12px" target="_blank"
								@click="openBook">CLICK HERE TO DOWNLOAD</a>
						</div>
						<div :style="'background-image:url(' + pages8[251] + ')'"></div>
						<div :style="'background-image:url(' + pages8[252] + ')'"></div>
						<div :style="'background-image:url(' + pages8[253] + ')'"></div>
						<div :style="'background-image:url(' + pages8[254] + ')'"></div>
						<div :style="'background-image:url(' + pages8[255] + ')'"></div>
						<div :style="'background-image:url(' + pages8[256] + ')'">
							<a class="minilinks articles2" style="bottom: 10.5%; left: 47.4%; width: 16.6%;" target="_blank"
								@click="openLink('https://sudanartistfund.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[257] + ')'"></div>
						<div :style="'background-image:url(' + pages8[258] + ')'"></div>
						<div :style="'background-image:url(' + pages8[259] + ')'"></div>
						<div :style="'background-image:url(' + pages8[260] + ')'"></div>
						<div :style="'background-image:url(' + pages8[261] + ')'"></div>
						<div :style="'background-image:url(' + pages8[262] + ')'"></div>
						<div :style="'background-image:url(' + pages8[263] + ')'"></div>
						<div :style="'background-image:url(' + pages8[264] + ')'"></div>
						<div :style="'background-image:url(' + pages8[265] + ')'"></div>
						<div :style="'background-image:url(' + pages8[266] + ')'"></div>
						<div :style="'background-image:url(' + pages8[267] + ')'"></div>
						<div :style="'background-image:url(' + pages8[268] + ')'">
							<a class="minilinks articles2" style="bottom: 10.5%; left: 47.4%; width: 14.5%;" target="_blank"
								@click="openLink('https://www.instagram.com/kiara_nirghin/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[269] + ')'"></div>
						<div :style="'background-image:url(' + pages8[270] + ')'"></div>
						<div :style="'background-image:url(' + pages8[271] + ')'"></div>
						<div :style="'background-image:url(' + pages8[272] + ')'"></div>
						<div :style="'background-image:url(' + pages8[273] + ')'"></div>
						<div :style="'background-image:url(' + pages8[274] + ')'"></div>
						<div :style="'background-image:url(' + pages8[275] + ')'"></div>
						<div :style="'background-image:url(' + pages8[276] + ')'"></div>
						<div :style="'background-image:url(' + pages8[277] + ')'"></div>
						<div :style="'background-image:url(' + pages8[278] + ')'">
							<a class="minilinks articles2" style="bottom: 10.5%; left: 47.4%; width: 10%;" target="_blank"
								@click="openLink('https://www.facebook.com/MENCERTC')">clik</a>
					</div>
						<div :style="'background-image:url(' + pages8[279] + ')'"></div>
						<div :style="'background-image:url(' + pages8[280] + ')'"></div>
						<div :style="'background-image:url(' + pages8[281] + ')'"></div>
						<div :style="'background-image:url(' + pages8[282] + ')'"></div>
						<div :style="'background-image:url(' + pages8[283] + ')'">
							<a class="minilinks articles2" style="bottom: 29.3%; left: 55.6%; width: 12.4%;" target="_blank"
								@click="openLink('https://www.instagram.com/ralftoenjes/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[284] + ')'"></div>
						<div :style="'background-image:url(' + pages8[285] + ')'">
							<a class="minilinks articles2" style="bottom: 10.4%; left: 45%; width:8%" target="_blank"
								@click="openLink('https://jedrzej.fr/')">clik</a>
							</div>
						<div :style="'background-image:url(' + pages8[286] + ')'"></div>
						<div :style="'background-image:url(' + pages8[287] + ')'">
							<a class="minilinks articles2" style="bottom: 11.3%; right: 0%; width: 14%;" target="_blank"
								@click="openLink('https://georgeosodi.photoshelter.com/index')">clik</a>
							</div>
						<div :style="'background-image:url(' + pages8[288] + ')'">
							<a class="minilinks articles2" style="bottom: 11.3%; left: 0%; width: 12.4%;" target="_blank"
								@click="openLink('https://georgeosodi.photoshelter.com/index')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[289] + ')'">
							<a class="minilinks articles2" style="bottom: 10.5%; left: 40.4%; width: 17.2%;" target="_blank"
								@click="openLink('https://galerienumber8.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[290] + ')'">
							<a class="minilinks articles2" style="bottom: 9.6%; left: 43%; width: 16.2%;" target="_blank"
								@click="openLink('https://www.mahtabhussain.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[291] + ')'">
							<a class="minilinks articles2" style="bottom: 11%; left: 44%; width: 10.2%;" target="_blank"
								@click="openLink('https://www.tiwani.co.uk/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[292] + ')'">
							<a class="minilinks articles2" style="bottom: 9.9%; left: 44.8%; width: 13%;" target="_blank"
								@click="openLink('https://www.kurttong.co.uk/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[293] + ')'">
							<a class="minilinks articles2" style="left: 48.2%; width: 13.2%; bottom: 11%;" target="_blank"
								@click="openLink('https://www.thkgallery.com/artists/49-nonzuzo-gxekwa/overview/')">clik</a>>
						</div>
						<div :style="'background-image:url(' + pages8[294] + ')'">
							<a class="minilinks articles2" style="bottom: 9.4%; left: 42.6%; width: 17.4%;" target="_blank"
								@click="openLink('https://www.nicholas-hughes.net/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[295] + ')'">
							<a class="minilinks articles2" style="right: 0%; width: 6%; bottom: 9.7%;" target="_blank"
								@click="openLink('https://chiyinsim.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[296] + ')'">
							<a class="minilinks articles2" style="left: 0%; width: 6%; bottom: 9.7%;" target="_blank"
								@click="openLink('https://chiyinsim.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[297] + ')'">
							<a class="minilinks articles2" style="left: 41%; width: 16.7%; bottom: 9.8%;" target="_blank"
								@click="openLink('https://christopheguye.com/artists/seba-kurtis/biography')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[298] + ')'">
							<a class="minilinks articles2" style="left: 42.8%; width: 19%; bottom: 9.8%;" target="_blank"
								@click="openLink('http://www.zora-murff.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[299] + ')'"></div>
						<div :style="'background-image:url(' + pages8[300] + ')'"></div>
						<div :style="'background-image:url(' + pages8[301] + ')'"></div>
						<div :style="'background-image:url(' + pages8[302] + ')'">
							<a class="minilinks articles2" style="left: 54.2%; width: 16.5%; bottom: 65.6%;" target="_blank"
								@click="openLink('https://www.instagram.com/tararusaurious/?hl=en-gb')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[303] + ')'"></div>
						<div :style="'background-image:url(' + pages8[304] + ')'"></div>
						<div :style="'background-image:url(' + pages8[305] + ')'"></div>
						<div :style="'background-image:url(' + pages8[306] + ')'"></div>
						<div :style="'background-image:url(' + pages8[307] + ')'"></div>
						<div :style="'background-image:url(' + pages8[308] + ')'"></div>
						<div :style="'background-image:url(' + pages8[309] + ')'"></div>
						<div :style="'background-image:url(' + pages8[310] + ')'"></div>
						<div :style="'background-image:url(' + pages8[311] + ')'"></div>
						<div :style="'background-image:url(' + pages8[312] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 37.2%; width: 15.2%;" target="_blank"
								@click="openLink('https://thehouseofslay.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[313] + ')'"></div>
						<div :style="'background-image:url(' + pages8[314] + ')'"></div>
						<div :style="'background-image:url(' + pages8[315] + ')'">
							<a class="minilinks articles2" style="bottom: 10%; right: 5%; width: 8%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[316] + ')'"></div>
						<div :style="'background-image:url(' + pages8[317] + ')'"></div>
						<div :style="'background-image:url(' + pages8[318] + ')'">
							<a class="minilinks articles2" style="bottom: 10.9%; left: 15%; width: 6.4%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[319] + ')'">
							<a class="minilinks articles2" style="bottom: 22%; right: 7%; width: 6.5%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
							<a class="minilinks articles2" style="bottom: 10%; right: 6.7%; width: 6.5%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[320] + ')'"></div>
						<div :style="'background-image:url(' + pages8[321] + ')'">
							<a class="minilinks articles2" style="bottom: 10%; right: 6%; width: 6.5%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[322] + ')'"></div>
						<div :style="'background-image:url(' + pages8[323] + ')'"></div>
						<div :style="'background-image:url(' + pages8[324] + ')'"></div>
						<div :style="'background-image:url(' + pages8[325] + ')'"></div>
						<div :style="'background-image:url(' + pages8[326] + ')'"></div>
						<div :style="'background-image:url(' + pages8[327] + ')'">
							<a class="minilinks articles2" style="bottom: 10%; right: 6%; width: 6.5%;"  target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[328] + ')'"></div>
						<div :style="'background-image:url(' + pages8[329] + ')'"></div>
						<div :style="'background-image:url(' + pages8[330] + ')'"></div>
						<div :style="'background-image:url(' + pages8[331] + ')'"></div>
						<div :style="'background-image:url(' + pages8[332] + ')'">
							<a class="links articles2" style="bottom: 10.5%; right: 44%; width: 8.5%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[333] + ')'">
							<a class="minilinks articles2" style="bottom: 10.5%; right: 12.8%; width: 7%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[334] + ')'">
							<a class="minilinks articles2" style="bottom: 10.4%; left: 14.5%; width: 7%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[335] + ')'"></div>
						<div :style="'background-image:url(' + pages8[336] + ')'"></div>
						<div :style="'background-image:url(' + pages8[337] + ')'"></div>
						<div :style="'background-image:url(' + pages8[338] + ')'">
							<a class="links articles2" style="bottom: 58.6%; left: 54%; width: 15%" target="_blank"
								@click="openLink('https://www.instagram.com/uditsinghal_/?hl=en')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[339] + ')'"></div>
						<div :style="'background-image:url(' + pages8[340] + ')'"></div>
						<div :style="'background-image:url(' + pages8[341] + ')'"></div>
						<div :style="'background-image:url(' + pages8[342] + ')'"></div>
						<div :style="'background-image:url(' + pages8[343] + ')'"></div>
						<div :style="'background-image:url(' + pages8[344] + ')'">
							<a class="links articles2" style="bottom: 10%; left: 47.8%; width: 11.5%;" target="_blank"
								@click="openLink('https://www.instagram.com/katgraham/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[345] + ')'"></div>
						<div :style="'background-image:url(' + pages8[346] + ')'"></div>
						<div :style="'background-image:url(' + pages8[347] + ')'">
							<a class="links articles2" style="bottom: 16%; right: 7%; width: 5%;" target="_blank"
								@click="openLink('https://www.gucci.com/us/en/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[348] + ')'"></div>
						<div :style="'background-image:url(' + pages8[349] + ')'">
							<a class="links articles2" style="bottom: 15%; left: 53%; width: 9.5%;" target="_blank"
								@click="openLink('https://www.balenciaga.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[350] + ')'"></div>
						<div :style="'background-image:url(' + pages8[351] + ')'"></div>
						<div :style="'background-image:url(' + pages8[352] + ')'">
							<a class="links articles2" style="bottom: 15%; left: 46.5%; width: 18.6%;" target="_blank"
								@click="openLink('https://www.alexandermcqueen.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[353] + ')'"></div>
						<div :style="'background-image:url(' + pages8[354] + ')'">
							<a class="links articles2" style="bottom: 15%; left: 52.5%; width: 12.2%;" target="_blank"
								@click="openLink('https://us.louisvuitton.com/eng-us/homepage')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[355] + ')'">
							<a class="links articles2" style="bottom: 15%; left: 54.5%; width: 8%;" target="_blank"
								@click="openLink('https://www.givenchy.com/us/en-US/homepage')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[356] + ')'"></div>
						<div :style="'background-image:url(' + pages8[357] + ')'"></div>
						<div :style="'background-image:url(' + pages8[358] + ')'">
							<a class="minilinks articles2" style="bottom: 15%; left: 39%; width: 6.5%;" target="_blank"
								@click="openLink('https://www.chanel.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[359] + ')'">
							<a class="minilinks articles2" style="bottom: 13.5%; left: 57%; width: 5%;" target="_blank"
								@click="openLink('https://www.chloe.com/us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[360] + ')'"></div>
						<div :style="'background-image:url(' + pages8[361] + ')'">
							<a class="minilinks articles2" style="bottom: 16.4%; right: 22%; width: 5.6%;" target="_blank"
								@click="openLink('https://www.prada.com/us/en.html')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[362] + ')'"></div>
						<div :style="'background-image:url(' + pages8[363] + ')'"></div>
						<div :style="'background-image:url(' + pages8[364] + ')'"></div>
						<div :style="'background-image:url(' + pages8[365] + ')'">
							<a class="minilinks articles2" style="bottom: 15%; left: 20%; width: 12%;" target="_blank"
								@click="openLink('https://us.louisvuitton.com/eng-us/homepage')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[366] + ')'"></div>
						<div :style="'background-image:url(' + pages8[367] + ')'"></div>
						<div :style="'background-image:url(' + pages8[368] + ')'">
							<a class="minilinks articles2" style="bottom: 16.6%; width: 12.5%; right: 7%;" target="_blank"
								@click="openLink('https://us.louisvuitton.com/eng-us/homepage')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[369] + ')'">
							<a class="minilinks articles2" style="bottom: 81.4%; left: 8.8%; width: 14%;" target="_blank"
								@click="openLink('https://www.bottegaveneta.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[370] + ')'">
							<a class="minilinks articles2" style="bottom: 22.7%; width: 16.4%; right: 7%;" target="_blank"
								@click="openLink('https://www.isseymiyake.com/en/brands/hommeplisse')">clik</a>
							<a class="minilinks articles2" style="bottom: 16.5%; width: 12%; right: 7%;" target="_blank"
								@click="openLink('https://us.louisvuitton.com/eng-us/homepage')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[371] + ')'">
							<a class="minilinks articles2" style="bottom: 18.8%; left: 27.2%; width: 6%;" target="_blank"
								@click="openLink('https://www.stellamccartney.com/us/en/')">clik</a>
							<a class="minilinks articles2" style="bottom: 17%; left: 7%; width: 10%;" target="_blank"
								@click="openLink('https://www.stellamccartney.com/us/en/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[372] + ')'"></div>
						<div :style="'background-image:url(' + pages8[373] + ')'">
							<a class="minilinks articles2" style="bottom: 74.5%; left: 11%; width: 11%;" target="_blank"
								@click="openLink('https://craig-green.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[374] + ')'">
							<a class="minilinks articles2" style="bottom: 16.9%; right: 6%; width: 10%;" target="_blank"
								@click="openLink('https://www.balenciaga.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[375] + ')'">
							<a class="minilinks articles2" style="bottom: 80.2%; left: 7%; width: 18%;" target="_blank"
								@click="openLink('https://www.alexandermcqueen.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[376] + ')'">
							<a class="minilinks articles2" style="bottom: 13.4%; left: 6%; width: 18%;" target="_blank"
								@click="openLink('https://www.alexandermcqueen.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[377] + ')'">
							<a class="minilinks articles2" style="bottom: 24%; right: 19%; width: 9%;" target="_blank"
								@click="openLink('https://roksanda.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 22.2%; right: 6%; width: 14%;" target="_blank"
								@click="openLink('https://www.matchesfashion.com/intl/womens')">clik</a>
							<a class="minilinks articles2" style="bottom: 11.9%; right: 5%; width: 7%;" target="_blank"
								@click="openLink('https://www.gucci.com/us/en/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[378] + ')'"></div>
						<div :style="'background-image:url(' + pages8[379] + ')'"></div>
						<div :style="'background-image:url(' + pages8[380] + ')'">
							<a class="minilinks articles2" style="bottom: 17%; right: 6.8%; width: 5.5%;" target="_blank"
								@click="openLink('https://erdem.com/collections/all')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[381] + ')'">
							<a class="minilinks articles2" style="bottom: 13.5%; width: 9.4%; right: 6%;" target="_blank"
								@click="openLink('https://casablancaparis.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 10%; right: 6%; width: 12%;" target="_blank"
								@click="openLink('https://us.louisvuitton.com/eng-us/homepage')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[382] + ')'">
							<a class="minilinks articles2" style="bottom: 13.5%; width: 4%; left: 25.5%;" target="_blank"
								@click="openLink('https://www.instagram.com/emildernbach/?hl=en')">clik</a>
							<a class="minilinks articles2" style="bottom: 11.8%; width: 8%; left: 5.6%;" target="_blank"
								@click="openLink('https://www.instagram.com/emildernbach/?hl=en')">clik</a>
							<a class="minilinks articles2" style="bottom: 9.8%; left: 5.6%; width: 21%;" target="_blank"
								@click="openLink('https://dearfrances.com/?gclid=Cj0KCQjwsrWZBhC4ARIsAGGUJurq3tjFEnNegW8pjulL3YmN1fldNpHio2flqL3hovkt7FwkWQRXKhQaAlVgEALw_wcB')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[383] + ')'">
							<a class="minilinks articles2"  style="bottom: 12.5%; width: 14%; right: 2%;" target="_blank"
								@click="openLink('http://www.richard-malone.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 10.7%; right: 2%; width: 13%;" target="_blank"
								@click="openLink('https://mollygoddard.com/')">clik</a>
					</div>
						<div :style="'background-image:url(' + pages8[384] + ')'"></div>
						<div :style="'background-image:url(' + pages8[385] + ')'">
							<a class="minilinks articles2" style="bottom: 16.9%; width: 5.6%; left: 21%;" target="_blank"
								@click="openLink('https://www.loewe.com/usa/en/home')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[386] + ')'">
							<a class="minilinks articles2" style="bottom: 18.6%; width: 14%; left: 18%;" target="_blank"
								@click="openLink('https://mollygoddard.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 16.8%; width: 6%; left: 28.6%;" target="_blank"
								@click="openLink('https://mollygoddard.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 15.2%; width: 8%; left: 5.6%;" target="_blank"
								@click="openLink('https://mollygoddard.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:13%; left: 15.2%; width: 17%;" target="_blank"
								@click="openLink('https://www.stellamccartney.com/us/en/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[387] + ')'">
							<a class="minilinks articles2" style="bottom: 17%; width: 7%; left: 26.5%;" target="_blank"
								@click="openLink('https://www.chetlo.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[388] + ')'"></div>
						<div :style="'background-image:url(' + pages8[389] + ')'"></div>
						<div :style="'background-image:url(' + pages8[390] + ')'">
							<div class="video1">
								<vue-player ref="video1" id="video1"
									src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-8%2Fmedia%2Fpg389.mov?alt=media&token=6e9b592e-7359-49f6-a953-bda0cdd98b4b">
								</vue-player>
							</div>
							<a class="minilinks articles2"
								style="position: absolute; bottom: 27.5%; left: 79.5%; width: 14%; font-size: 1em; border-bottom: none !important"
								@click.prevent="playVideo1">ClickToPlay</a>
						</div>
						<div :style="'background-image:url(' + pages8[391] + ')'"></div>
						<div :style="'background-image:url(' + pages8[392] + ')'"></div>
						<div :style="'background-image:url(' + pages8[393] + ')'">
							<a class="minilinks articles2" style="bottom: 15%; left: 18%; width: 10.5%;" target="_blank"
								@click="openLink('https://www.balenciaga.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[394] + ')'"></div>
						<div :style="'background-image:url(' + pages8[395] + ')'">
							<a class="minilinks articles2" style="bottom: 15.8%; left: 30.5%; width: 5.6%;" target="_blank"
								@click="openLink('https://www.prada.com/us/en.html')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[396] + ')'">
							<a class="minilinks articles2" style="bottom: 83%; right: 7%; width: 13.5%;" target="_blank"
								@click="openLink('https://us.louisvuitton.com/eng-us/homepage')">clik</a>
							<a class="minilinks articles2" style="bottom: 79.3%; right: 7%; width: 13.5%;" target="_blank"
								@click="openLink('https://www.ralphlauren.com/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[397] + ')'">
							<a class="minilinks articles2" style="bottom: 28%; left: 14%; width: 8%;" target="_blank"
								@click="openLink('https://www.chloe.com/us')">clik</a>
							<a class="minilinks articles2" style="bottom: 21.8%; left: 5%; width: 12.5%; font-size: 1.2em;" target="_blank"
								@click="openLink('https://www.alexandermcqueen.com/en-us')">clik</a>								
						</div>
						<div :style="'background-image:url(' + pages8[398] + ')'">
							<a class="minilinks articles2" style="bottom: 75.4%; right: 5%; width: 7%;" target="_blank"
								@click="openLink('https://www.chloe.com/us')">clik</a>
							</div>
						<div :style="'background-image:url(' + pages8[399] + ')'">
							<a class="minilinks articles2" style="bottom: 13.4%; right: 11%; width: 8.5%;" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[400] + ')'">
							<a class="minilinks articles2" style="bottom: 82.8%; right: 6%; width: 	19%;" target="_blank"
								@click="openLink('https://www.alexandermcqueen.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[401] + ')'">
							<a class="minilinks articles2" style="bottom: 39.5%; left: 28%; width: 6%;" target="_blank"
								@click="openLink('https://www.ysl.com/en-us')">clik</a>
							<a class="minilinks articles2" style="bottom: 37.6%; left: 10%; width: 29%;" target="_blank"
								@click="openLink('https://www.ysl.com/en-us')">clik</a>
							<a class="minilinks articles2" style="bottom: 30.8%; left: 26%; width: 13%;" target="_blank"
								@click="openLink('https://www.ysl.com/en-us')">clik</a>
							<a class="minilinks articles2" style="bottom: 29%; left: 10%; width: 22%;" target="_blank"
								@click="openLink('https://www.ysl.com/en-us')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[402] + ')'"></div>
						<div :style="'background-image:url(' + pages8[403] + ')'"></div>
						<div :style="'background-image:url(' + pages8[404] + ')'"></div>
						<div :style="'background-image:url(' + pages8[405] + ')'"></div>
						<div :style="'background-image:url(' + pages8[406] + ')'">
							<a class="minilinks articles2" style="bottom: 60.8%; left: 54.3%; width: 10.6%;" target="_blank"
								@click="openLink('https://www.instagram.com/neezario/')">clik</a>
						</div>
						<div :style="'background-image:url(' + pages8[407] + ')'">
							<!-- Stockits left A-->							
							<a class="minilinks articles2" style="bottom:66.7%; left: 6.8%; width: 13%;" target="_blank"
								@click="openLink('https://us.abelodor.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:  63%; left: 6.8%; width: 19%;" target="_blank"
								@click="openLink('https://www.alexandermcqueen.com/en-us')">clik</a>
							<a class="minilinks articles2" style="bottom:59.2%; left: 6.8%; width: 11.5%;" target="_blank"
								@click="openLink('https://www.aurstudio.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:55.5%; left: 6.8%; width: 11%;" target="_blank"
								@click="openLink('https://auterra.co.za/')">clik</a>
							<a class="minilinks articles2" style="bottom:51.8%; left: 6.8%; width: 11%;" target="_blank"
								@click="openLink('https://article22.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:48.1%; left: 6.8%; width: 7%" target="_blank"
								@click="openLink('https://ayni.com.pe/')">clik</a>
							<a class="minilinks articles2" style="bottom:44.4%; left: 6.8%; width: 12.5%" target="_blank"
								@click="openLink('https://www.balenciaga.com/en-us')">clik</a>
							<a class="minilinks articles2" style="bottom:40.7%; left: 6.8%; width: 14.5%" target="_blank"
								@click="openLink('https://www.bottegaveneta.com/en-us')">clik</a>
              <a class="minilinks articles2" style="bottom: 37%; left: 6.8%; width: 16.7%" target="_blank"
								@click="openLink('https://casablancaparis.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:33.3%; left: 6.8%; width: 9%" target="_blank"
								@click="openLink('https://www.chanel.com/us/')">clik</a>
							<a class="minilinks articles2" style="bottom:29.6%; left: 6.8%; width: 16.5%" target="_blank"
								@click="openLink('https://www.charlottetilbury.com/us/products/summer-sale?&nst=0&gclid=CjwKCAjw0dKXBhBPEiwA2bmObddWihP-s-p7WfBiA1CnjK77uQcJsIowBHmh9n8e7BAMSJ2uLC8BRhoCmHgQAvD_BwE&gclsrc=aw.ds')">clik</a>
							<a class="minilinks articles2" style="bottom:25.9%; left: 6.8%; width: 8%" target="_blank"
								@click="openLink('https://www.chetlo.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:22.2%; left: 6.8%; width: 7.5%" target="_blank"
								@click="openLink('https://www.chloe.com/us')">clik</a>
							<a class="minilinks articles2" style="bottom:18.4%; left: 6.8%; width: 17%" target="_blank"
								@click="openLink('https://colorfulstandard.com/')">clik</a>
							<!-- stockits center  A-->
              <a class="minilinks articles2" style="bottom:66.7%;  left: 37.5%; width: 13%" target="_blank"
								@click="openLink('https://craig-green.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:  63%;  left: 37.5%; width: 9%" target="_blank"
								@click="openLink('https://www.cuyana.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:59.2%;  left: 37.5%; width: 7%;" target="_blank"
								@click="openLink('https://www.dior.com/en_us')">clik</a>					
							<a class="minilinks articles2" style="bottom:55.5%; left: 37.5%; width: 8.8%" target="_blank"
								@click="openLink('https://erdem.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:51.8%;  left: 37.5%; width: 9.4%" target="_blank"
								@click="openLink('https://ethique.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:48.1%;  left: 37.5%; width: 11.4%" target="_blank"
								@click="openLink('https://www.fairphone.com/en/')">clik</a>
							<a class="minilinks articles2" style="bottom:44.4%;  left: 37.5%; width: 13.8%" target="_blank"
								@click="openLink('https://www.en.flamingoslife.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:40.7%;  left: 37.5%; width: 10.5%" target="_blank"
								@click="openLink('https://www.givenchy.com/us/en-US/homepage')">clik</a>
							<a class="minilinks articles2" style="bottom: 37%;  left: 37.5%; width: 11%" target="_blank"
								@click="openLink('https://gmbhgmbh.eu/shop/')">clik</a>
							<a class="minilinks articles2" style="bottom:33.3%; left: 37.5%; width: 16%" target="_blank"
								@click="openLink('https://goshcopenhagen.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:29.6%; left: 37.5%; width: 7.5%" target="_blank"
								@click="openLink('https://www.gucci.com/us/en/')">clik</a>
							<a class="minilinks articles2" style="bottom:25.9%; left: 37.5%; width: 11.2%" target="_blank"
								@click="openLink('https://haeckels.co.uk/')">clik</a>
							<a class="minilinks articles2" style="bottom:22.2%; left: 37.5%; width: 12.8%" target="_blank"
								@click="openLink('https://www.isseymiyake.com/en/brands/hommeplisse')">clik</a>
							<a class="minilinks articles2" style="bottom:18.4%; left: 37.5%; width: 18.6%" target="_blank"
								@click="openLink('https://houdinisportswear.com/en-us')">clik</a>
								<!-- stockits right  A-->
              <a class="minilinks articles2" style="bottom:66.7%;  left: 70%; width: 18.4%" target="_blank"
								@click="openLink('https://www.hourglasscosmetics.com/?gclid=CjwKCAjw0dKXBhBPEiwA2bmObcq9Swo6c3SxolIBWyKnuOSmz8cPICCmENb3tpdhTc6oj3kDby51phoC8bMQAvD_BwE&gclsrc=aw.ds')">clik</a>
							<a class="minilinks articles2" style="bottom:  63%; left: 70%; width: 13%" target="_blank"
								@click="openLink('https://jungleculture.eco/')">clik</a>
							<a class="minilinks articles2" style="bottom:59.2%;  left: 70%; width: 11%" target="_blank"
								@click="openLink('https://www.khalimin.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:55.5%;  left: 70%; width: 12%" target="_blank"
								@click="openLink('https://www.kmbylange.com')">clik</a>					
							<a class="minilinks articles2" style="bottom:51.8%; left: 70%; width: 16%" target="_blank"
								@click="openLink('https://www.kseniaschnaider.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:48.1%;  left: 70%; width: 8.2%" target="_blank"
								@click="openLink('https://www.loewe.com/usa/en/home')">clik</a>
							<a class="minilinks articles2" style="bottom:44.4%;  left: 70%; width: 16%" target="_blank"
								@click="openLink('https://us.louisvuitton.com/eng-us/homepage')">clik</a>
							<a class="minilinks articles2" style="bottom:40.7%;  left: 70%; width: 14%" target="_blank"
								@click="openLink('https://www.maccosmetics.com/?gclid=CjwKCAjw0dKXBhBPEiwA2bmObWKRH6qSVELD7J-EhQZtqU0Ruscjw5xMJI2x5xVaAyrMhMiDgcwBKxoCtuMQAvD_BwE&gclsrc=aw.ds')">clik</a>
							<a class="minilinks articles2" style="bottom: 37%;;  left: 70%; width: 8%" target="_blank"
								@click="openLink('https://maium.nl')">clik</a>
							<a class="minilinks articles2" style="bottom:33.3%; left: 70%; width: 12.4%" target="_blank"
								@click="openLink('https://make-land.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:29.6%; left: 70%; width: 16.8%" target="_blank"
								@click="openLink('https://www.makeupbymario.com/?gclid=CjwKCAjw0dKXBhBPEiwA2bmOba1QR0LR2UtNccY7S4H1Wlrjt35YE86jVph57-l93b0HZXbuvRHrSRoCmhwQAvD_BwE')">clik</a>
							<a class="minilinks articles2" style="bottom:25.9%; left: 70%; width: 7.4%" target="_blank"
								@click="openLink('https://maydi.co/en/')">clik</a>
							<a class="minilinks articles2" style="bottom:22.2%; left: 70%; width: 15%" target="_blank"
								@click="openLink('https://mollygoddard.com/')">clik</a>							
							<a class="minilinks articles2" style="bottom:18.4%; left: 70%; width: 17%" target="_blank"
								@click="openLink('https://oneseedperfumes.com/')">clik</a>							
            </div>
						<!-- Stockits left B-->
						<div :style="'background-image:url(' + pages8[408] + ')'">             
							<a class="minilinks articles2" style="bottom:66.7%;   left: 5.8%; width: 11%;" target="_blank"
								@click="openLink('https://www.ottolinger.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:  63%;   left: 5.8%; width: 18%;" target="_blank"
								@click="openLink('https://www.oxmantownskincare.ie/')">clik</a>
							<a class="minilinks articles2" style="bottom:59.2%;   left: 5.8%; width: 11.5%;" target="_blank"
								@click="openLink('https://www.paiskincare.us/')">clik</a>
							<a class="minilinks articles2" style="bottom:55.5%;   left: 5.8%; width: 11.2%;" target="_blank"
								@click="openLink('https://pajarapinta.co/')">clik</a>
							<a class="minilinks articles2" style="bottom:51.8%;   left: 5.8%; width: 13.5%;" target="_blank"
								@click="openLink('https://palaeyewear.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:48.1%;   left: 5.8%; width: 10%;" target="_blank"
								@click="openLink('https://pangaia.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:44.4%;   left: 5.8%; width: 12.5%" target="_blank"
								@click="openLink('https://www.patmcgrath.com/products/mothership-x-moonlit-seduction?gclid=CjwKCAjw0dKXBhBPEiwA2bmObUEvha62_hnoiSw6CziE_pHLiOlHcmSocgIILcMJ9XatfrwoamXgdhoCo5IQAvD_BwE&tm_campaign=sw_2020_q4_brand_core_terms_exact&utm_medium=cpc&utm_source=google&variant=40201372794949')">clik</a>
							<a class="minilinks articles2" style="bottom:40.7%;  left: 5.8%; width: 13.5%" target="_blank"
								@click="openLink('https://www.philiphuang.com/')">clik</a>
							<a class="minilinks articles2" style="bottom: 37%;;   left: 5.8%; width: 8.5%" target="_blank"
								@click="openLink('https://www.prada.com/us/en.html')">clik</a>
							<a class="minilinks articles2" style="bottom:33.3%; left: 5.8%; width: 13.2%" target="_blank"
								@click="openLink('https://www.ralphlauren.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:29.6%;  left: 5.8%; width: 16.5%" target="_blank"
								@click="openLink('http://www.richard-malone.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:25.9%;  left: 5.8%; width: 10%" target="_blank"
								@click="openLink('https://rifo-lab.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:22.2%;  left: 5.8%; width: 11%" target="_blank"
								@click="openLink('https://roksanda.com/')">clik</a>
							
              <!-- stockits right B-->		
							<a class="minilinks articles2" style="bottom: 68.6%; left: 36%; width: 13%" target="_blank"
								@click="openLink('https://dearfrances.com/?gclid=Cj0KCQjwsrWZBhC4ARIsAGGUJurq3tjFEnNegW8pjulL3YmN1fldNpHio2flqL3hovkt7FwkWQRXKhQaAlVgEALw_wcB')">clik</a>
							<a class="minilinks articles2" style="bottom: 64.9%; left: 36%; width: 16%" target="_blank"
								@click="openLink('https://www.matchesfashion.com/womens')">clik</a>
							<a class="minilinks articles2" style="bottom: 59.2%; left: 36%; width: 6%" target="_blank"
								@click="openLink('https://www.ysl.com/en-us')">clik</a>
							<a class="minilinks articles2" style="bottom:55.6%;   left: 36%; width: 16.8%;" target="_blank"
								@click="openLink('https://www.stefaniavaidani.com/en-us')">clik</a>												
							<a class="minilinks articles2" style="bottom:51.9%;  left: 36%; width: 16.8%" target="_blank"
								@click="openLink('https://www.stellamccartney.com/us/en/')">clik</a>
							<a class="minilinks articles2" style="bottom:48.1%;   left: 36%; width: 20%" target="_blank"
								@click="openLink('https://www.talabarbotinkhalidy.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:44.4%;   left: 36%; width: 18%" target="_blank"
								@click="openLink('https://www.thecommongoodco.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:40.7%;   left: 36%; width: 8.5%" target="_blank"
								@click="openLink('https://www.triwa.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:37%;   left: 36%; width: 14.2%" target="_blank"
								@click="openLink('https://unitedbyblue.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:33.5%; left: 36%; width: 14%" target="_blank"
								@click="openLink('https://us.viron-world.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:29.6%; left: 36%; width: 17%" target="_blank"
								@click="openLink('https://wawwaclothing.com/')">clik</a>
							<a class="minilinks articles2" style="bottom:26%; left: 36%; width: 19.5%" target="_blank"
								@click="openLink('https://wildmountainwax.com/')">clik</a>	
            </div>
						<div :style="'background-image:url(' + pages8[409] + ')'"></div>
						<div :style="'background-image:url(' + pages8[410] + ')'"></div>
						<div :style="'background-image:url(' + pages8[411] + ')'"></div>

						
						<div :style="'background-image:url(' + pages8[412] + ')'"></div>
						<div :style="'background-image:url(' + pages8[413] + ')'"></div>
						
					</div>
					<div class="flipbook-video video-content" id="video-Tbt" v-show="verTbt">
						<b-embed type="video" :src="infoModalTbt.src" id="videoTbt" autoplay allow="autoplay" :controls="false"
							allowfullscreen></b-embed>
					</div>
					<div class="flipbook-video video-content" id="video-Tfg" v-show="verTfg">
						<b-embed type="video" :src="infoModalTfg.src" id="videoTfg" autoplay allow="autoplay" :controls="false"
							allowfullscreen></b-embed>
					</div>
				</div>
				<index v-if="index"></index>
			</div>
		</div>
	</div>
</template>

<script>
import $ from "jquery";
import "@/lib/turn.js";
import "@/lib/zoom.js";
import "@/lib/hash.js";
import index from "./Index";
import loader from "../../containers/loader";
import vuePlayer from "@algoz098/vue-player";

import { mapState, mapActions, mapMutations } from "vuex";

export default {
  components: {
    index,
    loader,
    vuePlayer,
    // navIndex
  },
  data() {
    return {
      infoModalTbt: {
        src: "",
        isPlay: false,
      },
      verTbt: false,
      infoModalTfg: {
        src: "",
        isPlay: false,
      },
      verTfg: false,      
    };
  },

  created() {
     this.loadMagazine8();
  },
  mounted() {
    function loadApp() {
      $("#canvas").fadeIn(4000);

      var o = $(".flipbook");
      0 != o.width() && 0 != o.height()
        ? (o.turn({
          width: 1680,
          height: 1080,
          duration: 4000,
          acceleration: !isChrome(),
          gradients: !0,
          autoCenter: !0,
          elevation: 200,
          when: {
            turning: function (o, i, n) {
              	var e = $(this),
              	a = e.turn("page");
				e.turn("pages");
				var btnClick = document.getElementById('btnClick');
				/*Cuando se haga clic*/
				btnClick.onmousedown = function() {
					const media1 = document.getElementById("videoTbt");
					media1.pause();			
					const media2 = document.getElementById("videoTfg");
					media2.pause();
					$("#video-Tbt, #video-Tfg").hide();
				};
                

              disableControls(i),
                $(".thumbnails .page-" + a)
                  .parent()
                  .removeClass("current"),
                $(".thumbnails .page-" + i)
                  .parent()
                  .addClass("current");
            },
            turned: function (o, i, n) {
              disableControls(i), $(this).turn("center"), 1 == i && $(this).turn("peel", "br");
            },
            missing: function (o, i) {
              for (var n = 0; n < i.length; n++) addPage(i[n], $(this));
            },
          },
        }),
          $(".flipbook-viewport").zoom({
            flipbook: $(".flipbook"),
            max: function () {
              return largeMagazineWidth() / $(".flipbook").width();
            },
            when: {
              swipeLeft: function () {
                $(this).zoom("flipbook").turn("next");
              },
              swipeRight: function () {
                $(this).zoom("flipbook").turn("previous");
              },
              resize: function (o, i, n, e) {
                1 == i ? loadSmallPage(n, e) : loadLargePage(n, e);
              },
              zoomIn: function () {
                $(".thumbnails").hide(),
                  $(".made").hide(),
                  $(".flipbook").removeClass("animated").addClass("zoom-in"),
                  $(".zoom-icon").removeClass("zoom-icon-in").addClass("zoom-icon-out"),
                  window.escTip || $.isTouch || (escTip = !0);
              },
              zoomOut: function () {
                $(".exit-message").hide(),
                  $(".made").fadeIn(),
                  $(".zoom-icon").removeClass("zoom-icon-out").addClass("zoom-icon-in"),
                  setTimeout(function () {
                    $(".flipbook").addClass("animated").removeClass("zoom-in"), resizeViewport();
                  }, 0);
              },
            },
          }),
          // pasar hojas con flechas

          $(document).keydown(function (e) {
            var options = $(".flipbook").turn("options");

            var previous = 37,
              next = 39,
              esc = 27;

            switch (e.keyCode) {
              case previous:
                // left arrow
                $(".flipbook").turn("previous");
                e.preventDefault();
                break;

              case next:
                //right arrow
                $(".flipbook").turn("next");
                e.preventDefault();
                break;

              case esc:
                $(".flipbook").turn("size", options.width, options.height);
                e.preventDefault();

                break;
            }
          }),
          $(window)
            .resize(function () {
              resizeViewport();
            })
            .bind("orientationchange", function () {
              resizeViewport();
            }),
          // $.isTouch ? $(".flipbook").bind("touchstart", regionClick) : $(".flipbook").click(regionClick),
          resizeViewport(),
          $(".flipbook").addClass("animated"))
        : setTimeout(loadApp, 10);
    }

    $(".zoom-icon")
      .bind("mouseover", function () {
        $(this).hasClass("zoom-icon-in") && $(this).addClass("zoom-icon-in-hover"),
          $(this).hasClass("zoom-icon-out") && $(this).addClass("zoom-icon-out-hover");
      })
      .on("mouseout", function () {
        $(this).hasClass("zoom-icon-in") && $(this).removeClass("zoom-icon-in-hover"),
          $(this).hasClass("zoom-icon-out") && $(this).removeClass("zoom-icon-out-hover");
      })
      .on("click", function () {
        toggleFullscreen();
      }),
      $("#canvas").hide();

    //FUNCTIONS TURNJS
    function resizeViewport() {
      var width = $(window).width(),
        height = $(window).height(),
        options = $(".flipbook").turn("options");

      $(".flipbook").removeClass("animated");

      $(".flipbook-viewport")
        .css({
          width: width,
          height: height,
        })
        .zoom("resize");

      if ($(".flipbook").turn("zoom") == 1) {
        var bound = calculateBound({
          width: options.width,
          height: options.height,
          boundWidth: Math.min(options.width, width),
          boundHeight: Math.min(options.height, height),
        });

        if (bound.width % 2 !== 0) bound.width -= 1;

        if (bound.width != $(".flipbook").width() || bound.height != $(".flipbook").height()) {
          $(".flipbook").turn("size", bound.width, bound.height);

          if ($(".flipbook").turn("page") == 1) $(".flipbook").turn("peel", "br");

          $(".next-button").css({
            height: bound.height,
            backgroundPosition: "-38px " + (bound.height / 2 - 32 / 2) + "px",
          });
          $(".previous-button").css({
            height: bound.height,
            backgroundPosition: "-4px " + (bound.height / 2 - 32 / 2) + "px",
          });
        }

        $(".flipbook").css({
          top: -bound.height / 2,
          left: -bound.width / 2,
        });
        $(".flipbook-video").css({
          width: bound.width + 10,
          height: bound.height,
          top: -bound.height / 2,
          left: -bound.width / 2,
          padding: 0,
        });
      }

      var magazineOffset = $(".flipbook").offset(),
        boundH = height - magazineOffset.top - $(".flipbook").height(),
        marginTop = (boundH - $(".thumbnails > div").height()) / 2;

      if (marginTop < 0) {
        $(".thumbnails").css({
          height: 1,
        });
      } else {
        $(".thumbnails").css({
          height: boundH,
        });
        $(".thumbnails > div").css({
          marginTop: marginTop,
        });
      }

      if (magazineOffset.top < $(".made").height()) $(".made").hide();
      else $(".made").show();

      $(".flipbook").addClass("animated");
    }

    function isChrome() {
      return navigator.userAgent.indexOf("Chrome") != -1;
    }

    function calculateBound(d) {
      var bound = {
        width: d.width,
        height: d.height,
      };

      if (bound.width > d.boundWidth || bound.height > d.boundHeight) {
        var rel = bound.width / bound.height;

        if (d.boundWidth / rel > d.boundHeight && d.boundHeight * rel <= d.boundWidth) {
          bound.width = Math.round(d.boundHeight * rel);
          bound.height = d.boundHeight;
        } else {
          bound.width = d.boundWidth;
          bound.height = Math.round(d.boundWidth / rel);
        }
      }

      return bound;
    }

    function toggleFullscreen(elem) {
      var options = $(".flipbook").turn("options");

      elem = elem || document.documentElement;
      if (
        !document.fullscreenElement &&
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement &&
        !document.msFullscreenElement
      ) {
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          $(".flipbook").turn("zoom", 1.2);
          $(".flipbook").turn("center");
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
          $(".flipbook").turn("zoom", 1.2);
          $(".flipbook").turn("center");
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
          $(".flipbook").turn("zoom", 1.2);
          $(".flipbook").turn("center");
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          $(".flipbook").turn("zoom", 1.2);
          $(".flipbook").turn("center");
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
        }
      }
    }

    function disableControls(page) {
      if (page == 1) $(".previous-button").hide();
      else $(".previous-button").show();

      if (page == $(".flipbook").turn("pages")) $(".next-button").hide();
      else $(".next-button").show();
    }

    function loadSmallPage(page, pageElement) {
      var img = pageElement.find("img");

      img.css({
        width: "100%",
        height: "100%",
      });

      img.unbind("load");
    }
    // large page
    function loadLargePage(page, pageElement) {
      var img = $("<div />");

   
      img.load(function () {
        var prevImg = pageElement.find("img");

        $(this).css({
          width: "100%",
          height: "100%",
        });
        $(this).appendTo(pageElement);
        prevImg.remove();
      });
    }
    loadApp();
  },
  methods: {  
    //modal embed

    cambiarEstado(newEstado) {
      this.estado = newEstado;
      if (newEstado == "/index") {
        this.setClass(true);
        this.pause();
        this.ver = false;
      } else {
        this.$router.push(this.estado);
        this.setClass(false);
        this.pause();
        this.ver = false;
      }
    },
    onPlayerReadyTbt(reproducir) {
      this.infoModalTbt.isPlay = true;
      this.infoModalTbt.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoTbt");
        media.load();
        media.play();
        this.infoModalTbt.isPlay = true;
        this.verTbt = true;
      }, 100);
    },
    onPlayerTfg(reproducir) {
      this.infoModalTfg.isPlay = true;
      this.infoModalTfg.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoTfg");
        media.load();
        media.play();
        this.infoModalTfg.isPlay = true;
        this.verTfg = true;
      }, 100);
    },
    openLink(url) {
      window.open(url);
    },
    openBook() {
      let route = this.$router.resolve("/colorbook/8");
      window.open(route.href, "_blank");
    },
    pause() {
      if (this.infoModalTbt.isPlay == true) {
        const media = document.getElementById("videoTbt");
        media.pause();
        this.verTbt = false;
        this.infoModalTbt.isPlay = false;
      }
      if (this.infoModalTfg.isPlay == true) {
        const media = document.getElementById("videoTfg");
        media.pause();
        this.verTfg = false;
        this.infoModalTfg.isPlay = false;
      }
      if (this.$refs.video1.playing == true) {
        this.$refs.video1.playing == false;
        this.$refs.video1.$refs.video.pause();
      }   
    },
    playVideo1() {
      this.$refs.video1.$refs.video.load();
      this.$refs.video1.$refs.video.play();
    },
    pageNext() {
      $(".flipbook").turn("next");
      this.pause();
    },
    pagePrev() {
      $(".flipbook").turn("previous");
      this.pause();
    },

    ...mapActions("magazine", ["loadMagazine8"]),
    ...mapMutations("magazine", ["setClass", "loadSmallPage", "loadLargePage"]),
	},
	computed: {  
		...mapState("magazine", ["index", "pages8", "loading", "media"]),
	},
};
</script>

<style lang="scss">
video {
	object-fit: cover !important;
}

.video1 {
	position: absolute;
	top: 4.5%;
	left: 5.5%;
	width: 88%;
	z-index: 12;
}

#video1 {
	.vue-video-player-controls {
		max-height: 5px !important;
		display: none;
		left: 7% !important;
		right: 7% !important;
		padding: 5px;
		position: absolute;
		bottom: 5% !important;
		background-color: rgba(0, 0, 0, 0) !important;
	}

	.start-button {
		width: auto;
		height: auto;
		border: none;
		border-radius: none;
		background-color: rgba(0, 0, 0, 0);
		cursor: none;
	}

	.button {
		width: 35px;
		border: none !important;
		color: rgba(0, 0, 0, 0) !important;
		background-color: transparent;
	}
}

.video2 {
	position: absolute;
	top: 30%;
	left: 5.6%;
	width: 88.5%;
	height: 41%;
	z-index: 12;
}

#video2 {
	.vue-video-player-controls {
		max-height: 5px !important;
		display: none;
		left: 7% !important;
		right: 7% !important;
		padding: 5px;
		position: absolute;
		bottom: 5% !important;
		background-color: rgba(0, 0, 0, 0) !important;
	}

	.start-button {
		width: auto;
		height: auto;
		border: none;
		border-radius: none;
		background-color: rgba(0, 0, 0, 0);
		cursor: none;
	}

	.button {
		width: 35px;
		border: none !important;
		color: rgba(0, 0, 0, 0) !important;
		background-color: transparent;
	}
}

.vue-video-player-controls {
	display: none !important;
}

.start-button {
	width: auto;
	height: auto;
	border: none;
	border-radius: none;
	background-color: rgba(0, 0, 0, 0) !important;
	cursor: none;
}

.vue-player-time-control {
	position: absolute;
	top: -5px;
	left: 0;
	padding-top: 0;
	color: rgba(255, 255, 255, 0.3) !important;
	display: block;
}

.button {
	width: 35px;
	border: none !important;
	color: rgba(0, 0, 0, 0) !important;
	background-color: transparent;
}

.minilinksblack {
	position: absolute;
	cursor: pointer;
	color: black;
	font-family: 'lemon_milkregular';
	font-style: italic;
	-webkit-font-smoothing: antialiased;
	font-size: 0.8em;
	z-index: 100;
	text-decoration: underline;
}

//Pg 244-245 videoWtsu
.video-content {
	.embed-responsive {
		position: absolute;
		z-index: 1000;
		width: 93.2%;
		height: 62.2%;
		top: 5.7%;
		left: 4.4%;
	}
}

.video-Fllts {
	.embed-responsive {
		position: absolute;
		z-index: 1000;
		width: 85.2%;
		height: 80.2%;
		top: 6.7%;
		left: 8.4%;
	}
}

/*   @media (max-width: 1366px){
.video-content {
  .embed-responsive {
       position: absolute;
    z-index: 1000;
    width: 93.2%;
    height: 62.2%;
    top: 5.7%;
    left: 4.8%;
  }
}
  } */
</style>
